var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.0001L3.08333 16.9167C2.81944 17.1806 2.51736 17.2397 2.17708 17.0938C1.8368 16.948 1.66667 16.6876 1.66667 16.3126V3.33341C1.66667 2.87508 1.82986 2.48272 2.15625 2.15633C2.48264 1.82994 2.875 1.66675 3.33333 1.66675H16.6667C17.125 1.66675 17.5174 1.82994 17.8438 2.15633C18.1701 2.48272 18.3333 2.87508 18.3333 3.33341V13.3334C18.3333 13.7917 18.1701 14.1841 17.8438 14.5105C17.5174 14.8369 17.125 15.0001 16.6667 15.0001H5ZM6.66667 9.16675C6.90278 9.16675 7.10069 9.08689 7.26042 8.92717C7.42014 8.76744 7.5 8.56953 7.5 8.33342C7.5 8.0973 7.42014 7.89939 7.26042 7.73967C7.10069 7.57994 6.90278 7.50008 6.66667 7.50008C6.43056 7.50008 6.23264 7.57994 6.07292 7.73967C5.91319 7.89939 5.83333 8.0973 5.83333 8.33342C5.83333 8.56953 5.91319 8.76744 6.07292 8.92717C6.23264 9.08689 6.43056 9.16675 6.66667 9.16675ZM10 9.16675C10.2361 9.16675 10.434 9.08689 10.5938 8.92717C10.7535 8.76744 10.8333 8.56953 10.8333 8.33342C10.8333 8.0973 10.7535 7.89939 10.5938 7.73967C10.434 7.57994 10.2361 7.50008 10 7.50008C9.76389 7.50008 9.56597 7.57994 9.40625 7.73967C9.24653 7.89939 9.16667 8.0973 9.16667 8.33342C9.16667 8.56953 9.24653 8.76744 9.40625 8.92717C9.56597 9.08689 9.76389 9.16675 10 9.16675ZM13.3333 9.16675C13.5694 9.16675 13.7674 9.08689 13.9271 8.92717C14.0868 8.76744 14.1667 8.56953 14.1667 8.33342C14.1667 8.0973 14.0868 7.89939 13.9271 7.73967C13.7674 7.57994 13.5694 7.50008 13.3333 7.50008C13.0972 7.50008 12.8993 7.57994 12.7396 7.73967C12.5799 7.89939 12.5 8.0973 12.5 8.33342C12.5 8.56953 12.5799 8.76744 12.7396 8.92717C12.8993 9.08689 13.0972 9.16675 13.3333 9.16675Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/icon_sms.3f6085db3d835862316d670aad50c91e.svg";
export { ForwardRef as ReactComponent };